import React from 'react';
import styles from './LikeCountButton.module.scss';
import {Heart} from '../Heart';
import {Button} from '../../../../components';
interface Props {
  likes: number;
  liked: boolean;
  large?: boolean;
}

export function LikeCountButton({likes, liked, large}: Props) {
  return (
    <Button large={large} onClick={() => {}}>
      <div className={styles.ButtonContent}>
        {`${abbrNum(likes, 1)}`}
        <div className={styles.HeartContainer}>
          <Heart size="small" liked={liked} />
        </div>
      </div>
    </Button>
  );
}

// shit from https://stackoverflow.com/questions/2685911/is-there-a-way-to-round-numbers-into-a-reader-friendly-format-e-g-1-1k
function abbrNum(number: number, decPlaces: number) {
  decPlaces = Math.pow(10, decPlaces);

  var abbrev = ['K', 'M', 'B', 'T'];

  for (var i = abbrev.length - 1; i >= 0; i--) {
    var size = Math.pow(10, (i + 1) * 3);

    if (size <= number) {
      number = Math.round((number * decPlaces) / size) / decPlaces;

      if (number === 1000 && i < abbrev.length - 1) {
        number = 1;
        i++;
      }

      return `${number}${abbrev[i]}`;
    }
  }

  return number;
}
